import { ConditionalOutput } from "./ConditionalOutput";
import { ConditionalOutputType } from "./ConditionalOutputType";
export class ConditionalOutputFactory {
  public static WithDefault<T>(...additionalValues: Array<ConditionalOutputType<T>>) {
    return new ConditionalOutput<T>(...additionalValues);
  }

  public static OnCondition<T>(condition: boolean, ...additionalValues: Array<ConditionalOutputType<T>>): ConditionalOutput<T> {
    return new ConditionalOutput<T>()
      .OnCondition(condition, ...additionalValues);
  }
}
